<style scoped>

  @media only screen and (max-width: 991px) {
    .form-segment {
      min-height: 600px !important;
    }
  }

  @media only screen and (min-width: 992px) {
    .form-segment {
      min-height: 800px !important;
    }
  }

</style>

<template>
  
  <div class="ui segment form-segment" :class="{ loading }">
    <h4 class="ui dividing header">Diagnóstico</h4>
    <div class="ui grid">
      <div class="six wide computer sixteen wide tablet sixteen wide mobile column">
        <select-dropdown ref="templateDropdown" selectLabel="Selecione um modelo..." @onChange="onChangeTemplate" />
      </div>
      <div v-show="template.organs" class="sixteen wide column" style="margin-top: -10px !important;">
        <div class="ui form">
          <div v-if="template.organs" v-for="(organ, index) in template.organs" class="fields">
            <diagnosis-text-editor :ref="'d-text-editor-' + index" :organ="organ.organ" />
          </div>
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">OBSERVAÇÕES <span v-if="isCommentsRequired" class="red text">*</span></label>
              <text-editor ref="commentsTextEditor" />
            </div>
          </div>
        </div>
      </div>      
    </div>
    <p v-if="!template.organs" class="grey text m-t-30">
      <i class="info circle icon"></i> Nenhum modelo selecionado
    </p>
  </div>

</template>

<script>

  import CertTemplateService from "@/services/cert-template-service"
  import DiagnosisTextEditor from "./diagnosis-text-editor"
  import { SelectDropdown, TextEditor } from "@/components"

  export default {
    
    name: "DiagnosisSegment",

    data() {
      return {
        loading: false,
        cert: {},
        template: {},
        templateService: new CertTemplateService(),
      }
    },

    components: {
      SelectDropdown,
      DiagnosisTextEditor,
      TextEditor,
    },

    computed: {
      isCommentsRequired() {
        return (this.template.organs && this.template.organs.length == 0)
      },
    },

    methods: {

      init(cert) {
        this.cert = this.$cloneObject(cert)
        this.loadTemplates()
      },

      onChangeTemplate(id) {
        
        if (id == this.template.id || this.loading)
          return

        this.cert.certTemplateId = id        
        this.refreshData()
        this.loadTemplateData()
      },

      refreshData() {
        this.cert = this.$cloneObject(this.cert)
      },

      async loadTemplates() {

        this.loading = true

        try {

          const templates = await this.templateService.findAll({
            attributes: ["id", "name"],
            order: ["name"],
          })

          this.$refs.templateDropdown.setValues(templates, this.cert.certTemplateId)

          if (this.cert.certTemplateId)
            await this.loadTemplateData()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false

          this.$emit("onLoaded")  
        }
      },

      async loadTemplateData() {

        this.loading = true
        this.template.organs = null

        try {

          this.template = await this.templateService.findById(this.cert.certTemplateId)

          if (this.$refs.commentsTextEditor)
            this.$refs.commentsTextEditor.setContents(this.template.commentsContents || [])
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      getData() {

        let comments = null
        let commentsContents = null        

        if (!this.$refs.commentsTextEditor.isEmpty()) {
          comments = this.$refs.commentsTextEditor.getText()
          commentsContents = this.$refs.commentsTextEditor.getContents({ toString: true })
        }

        const diagnosticsData = this.getDiagnosticsData()

        return { 
          certTemplateId: this.cert.certTemplateId, 
          diagnostics: diagnosticsData.diagnostics,
          hasEmptyDiagnostics: diagnosticsData.hasEmptyDiagnostics,
          template: this.template,
          comments,
          commentsContents,
        }
      },

      getDiagnosticsData() {

        let data = {
          diagnostics: [],
          hasEmptyDiagnostics: false,
        }

        if (!this.template.organs)
          return data

        this.template.organs.forEach((organ, index) => {
          
          const textEditor = this.$refs["d-text-editor-" + index][0]

          if (textEditor.isEmpty()) {
            data.hasEmptyDiagnostics = true
          } else {
            data.diagnostics.push({
              sequence: organ.sequence,
              organId: organ.organId,
              description: textEditor.getText(),
              descriptionContents: textEditor.getContents({ toString: true }),
            })
          }
        })

        return data
      },

      initDiagnostics(cert) {
        
        this.loading = true
        this.template.organs = null

        let organs = []

        cert.diagnostics.forEach((diagnosis) => {
          organs.push({
            organId: diagnosis.organ.id,
            sequence: diagnosis.sequence,
            organ: {
              id: diagnosis.organ.id,
              name: diagnosis.organ.name,
              description: diagnosis.organ.description,              
              changes: diagnosis.organ.changes,            
              defaultText: diagnosis.description,
              defaultTextContents: diagnosis.descriptionContents,
            }
          })
        })

        this.$refs.commentsTextEditor.clear()

        if (cert.commentsContents)
          this.$refs.commentsTextEditor.setContents(cert.commentsContents)

        setTimeout(() => {
          this.template.organs = organs.slice()
          this.loading = false
        }, 1000)
      },
    },
  }

</script>